<template>
  <div id="modal" class="fixed inset-0 w-full h-full bg-black p-10 bg-opacity-50 grid items-center justify-center z-[50] overflow-y-auto" :class="{ 'visible' : settingsModal, 'invisible' : !settingsModal }">
    <div id="modal-content" class="bg-white p-6 rounded-lg w-full mx-auto transition-all duration-300 ease-in-out relative" :class="{'opacity-100 scale-100': settingsModal, 'opacity-0 scale-50' : !settingsModal, '2xl:w-[934px]': type == 1, '2xl:w-[1110px]' : type == 2 || type == 3 || type == 4 }">
      <div class="absolute top-[-20px] end-[-20px]">
        <button type="button" class="border border-[#C1D5E5] flex justify-center items-center rounded-full outline-0 bg-white p-0 m-0 w-[44px] h-[44px]" @click="closeModal()">
          <svg xmlns="http://www.w3.org/2000/svg" width="18.273" height="18.272" viewBox="0 0 18.273 18.272">
            <path id="Path_2192" data-name="Path 2192" d="M10.81,9.272l7.115-7.115A1.184,1.184,0,0,0,16.252.483L9.136,7.6,2.021.483A1.184,1.184,0,0,0,.347,2.157L7.462,9.272.347,16.388a1.184,1.184,0,1,0,1.674,1.674l7.115-7.115,7.115,7.115a1.184,1.184,0,1,0,1.674-1.674Zm0,0" transform="translate(0 -0.136)" fill="#3e5463"/>
          </svg>
        </button>
      </div>
      <div class="flex justify-start items-start flex-wrap lg:flex-nowrap" v-if="!loading && userData">
        <div class="w-full lg:max-w-[260px] lg:min-w-[260px]">
          <div class="mb-[6px]">
            <button @click="setType(1)" type="button" :class="{ 'bg-[#3E5463]' : type === 1, 'bg-[#C1D5E5]' : type !== 1 }" class="flex justify-start items-center h-[64px] w-full px-[26px] rounded-[12px]">
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
                <g id="svgexport-6_32_" data-name="svgexport-6 (32)" transform="translate(-2 -2)">
                  <g id="_40-User" data-name="40-User">
                    <path :class="{ 'fill-white' : type === 1, 'fill-[#3e5463]' : type !== 1 }" id="Path_95" data-name="Path 95" d="M16,2a7,7,0,1,0,7,7,7,7,0,0,0-7-7Zm0,12a5,5,0,1,1,5-5A5,5,0,0,1,16,14Z"/>
                    <path :class="{ 'fill-white' : type === 1, 'fill-[#3e5463]' : type !== 1 }" id="Path_96" data-name="Path 96" d="M21.17,18H10.83A8.84,8.84,0,0,0,2,26.83,3.17,3.17,0,0,0,5.17,30H26.83A3.17,3.17,0,0,0,30,26.83,8.84,8.84,0,0,0,21.17,18Zm5.66,10H5.17A1.17,1.17,0,0,1,4,26.83,6.83,6.83,0,0,1,10.83,20H21.17A6.83,6.83,0,0,1,28,26.83,1.17,1.17,0,0,1,26.83,28Z"/>
                  </g>
                </g>
              </svg>
              <span class="text-[17px] lg:text-[22px] font-bold" :class="{ 'text-white' : type === 1, 'text-[#3E5463]' : type !== 1, 'ml-[15px] lg:ml-[31px]': lang === 'en','mr-[15px] lg:mr-[20px]' : lang === 'ar'  }">
                {{ lang === 'en' ? 'Account' : 'حساب' }}
              </span>
            </button>
          </div>
          <div class="mb-[6px]">

            <button @click="setType(2)" type="button" :class="{ 'bg-[#3E5463]' : type === 2, 'bg-[#C1D5E5]' : type !== 2 }" class="flex justify-start items-center h-[64px] w-full px-[26px] rounded-[12px]">
              <svg xmlns="http://www.w3.org/2000/svg" width="27.501" height="27.5" viewBox="0 0 27.501 27.5">
                <g id="svgexport-6_33_" data-name="svgexport-6 (33)" transform="translate(-2.249 -2.25)">
                  <g id="Line">
                    <path :class="{ 'fill-white' : type === 2, 'fill-[#3e5463]' : type !== 2 }" id="Path_97" data-name="Path 97" d="M27,29.75H11A2.75,2.75,0,0,1,8.25,27v-.45a7.75,7.75,0,0,1,0-15.1V5A2.75,2.75,0,0,1,11,2.25H22.17a2.74,2.74,0,0,1,1.95.81l4.82,4.82a2.74,2.74,0,0,1,.81,2V27A2.75,2.75,0,0,1,27,29.75Zm-17.25-3V27A1.25,1.25,0,0,0,11,28.25H27A1.25,1.25,0,0,0,28.25,27V10.75H24A2.75,2.75,0,0,1,21.25,8V3.75H11A1.25,1.25,0,0,0,9.75,5v6.25H10a7.75,7.75,0,1,1,0,15.5Zm.25-14A6.25,6.25,0,1,0,16.25,19,6.25,6.25,0,0,0,10,12.75ZM22.75,3.89V8A1.25,1.25,0,0,0,24,9.25h4.11a1.39,1.39,0,0,0-.23-.31L23.06,4.12a1.39,1.39,0,0,0-.31-.23ZM25,22.75H20a.75.75,0,0,1,0-1.5h5a.75.75,0,1,1,0,1.5ZM8.5,21.25A.74.74,0,0,1,8,21a.75.75,0,0,1,0-1l1.28-1.28V16a.75.75,0,1,1,1.5,0v3a.75.75,0,0,1-.22.53L9,21a.74.74,0,0,1-.5.25ZM25,18.75H21a.75.75,0,0,1,0-1.5h4a.75.75,0,1,1,0,1.5Zm0-4H20a.75.75,0,1,1,0-1.5h5a.75.75,0,1,1,0,1.5Zm-7-4H15a.75.75,0,0,1,0-1.5h3a.75.75,0,0,1,0,1.5Z"/>
                  </g>
                </g>
              </svg>
              <span class="text-[17px] lg:text-[22px] font-bold" :class="{ 'text-white' : type === 2, 'text-[#3E5463]' : type !== 2, 'ml-[15px] lg:ml-[31px]': lang === 'en','mr-[15px] lg:mr-[20px]' : lang === 'ar'  }">
                {{ lang === 'en' ? 'Order History' : 'تاريخ الطلب' }}
              </span>
            </button>
          </div>
          <div class="mb-[6px]">

            <button @click="setType(3)" type="button" :class="{ 'bg-[#3E5463]' : type === 3, 'bg-[#C1D5E5]' : type !== 3 }" class="flex justify-start items-center h-[64px] w-full px-[26px] rounded-[12px]">
              <svg xmlns="http://www.w3.org/2000/svg" width="32.675" height="26.95" viewBox="0 0 32.675 26.95">
                <g id="svgexport-6_35_" data-name="svgexport-6 (35)" transform="translate(0.25 -10.748)">
                  <path id="Path_99" data-name="Path 99" d="M30.61,15.137,7.581,11.03a1.887,1.887,0,0,0-2.165,1.528L3.934,21.066H1.815A1.817,1.817,0,0,0,0,22.881V35.633a1.817,1.817,0,0,0,1.815,1.815H25.3a1.817,1.817,0,0,0,1.815-1.815V31.149a2.651,2.651,0,0,0,1.944-.11,1.912,1.912,0,0,0,.9-1.3l2.166-12.424A1.884,1.884,0,0,0,30.61,15.137Zm-24.171-2.4A.841.841,0,0,1,7.4,12.05l23.028,4.108a.845.845,0,0,1,.674.981l-.357,2.051L6.08,14.791Zm19.643,22.9a.779.779,0,0,1-.778.778H1.815a.779.779,0,0,1-.778-.778V22.881a.779.779,0,0,1,.778-.778H25.3a.779.779,0,0,1,.778.778Zm2.855-6.07c-.161.922-1.185.645-1.818.532V22.881A1.817,1.817,0,0,0,25.3,21.066H4.987L5.9,15.812l1.5.268,23.162,4.131Z" :class="{ 'fill-white stroke-white' : type === 3, 'fill-[#3e5463] stroke-[#3e5463]' : type !== 3 }" stroke-width="0.5"/>
                  <path id="Path_100" data-name="Path 100" d="M37.119,98.04H34.138a.519.519,0,1,1,0-1.037h2.982a.519.519,0,1,1,0,1.037Z" transform="translate(-24.902 -63.702)" :class="{ 'fill-white stroke-white' : type === 3, 'fill-[#3e5463] stroke-[#3e5463]' : type !== 3 }" stroke-width="0.5"/>
                  <path id="Path_101" data-name="Path 101" d="M15.271,98.04H12.29a.519.519,0,0,1,0-1.037h2.982a.519.519,0,0,1,0,1.037Z" transform="translate(-8.719 -63.702)" :class="{ 'fill-white stroke-white' : type === 3, 'fill-[#3e5463] stroke-[#3e5463]' : type !== 3 }" stroke-width="0.5"/>
                  <path id="Path_102" data-name="Path 102" d="M58.967,98.04H55.986a.519.519,0,1,1,0-1.037h2.982a.519.519,0,1,1,0,1.037Z" transform="translate(-41.085 -63.702)" :class="{ 'fill-white stroke-white' : type === 3, 'fill-[#3e5463] stroke-[#3e5463]' : type !== 3 }" stroke-width="0.5"/>
                  <path id="Path_103" data-name="Path 103" d="M80.816,98.04H77.835a.519.519,0,0,1,0-1.037h2.982a.519.519,0,0,1,0,1.037Z" transform="translate(-57.269 -63.702)" :class="{ 'fill-white stroke-white' : type === 3, 'fill-[#3e5463] stroke-[#3e5463]' : type !== 3 }" stroke-width="0.5"/>
                  <path id="Path_104" data-name="Path 104" d="M16,78.965H12.248a1.3,1.3,0,0,1-1.3-1.3V76.179a1.3,1.3,0,0,1,1.3-1.3H16a1.3,1.3,0,0,1,1.3,1.3v1.489A1.3,1.3,0,0,1,16,78.965ZM12.248,75.92a.26.26,0,0,0-.259.259v1.489a.26.26,0,0,0,.259.259H16a.26.26,0,0,0,.259-.259V76.179A.26.26,0,0,0,16,75.92Z" transform="translate(-8.112 -47.318)" :class="{ 'fill-white stroke-white' : type === 3, 'fill-[#3e5463] stroke-[#3e5463]' : type !== 3 }" stroke-width="0.5"/>
                </g>
              </svg>
              <span class="text-[17px] lg:text-[22px] font-bold" :class="{ 'text-white' : type === 3, 'text-[#3E5463]' : type !== 3, 'ml-[15px] lg:ml-[31px]': lang === 'en','mr-[15px] lg:mr-[20px]' : lang === 'ar' }">
                {{ lang === 'en' ? 'Payments' : 'المدفوعات' }}
              </span>
            </button>
          </div>
          <div class="mb-[6px]">
            <button @click="setType(4)" type="button" :class="{ 'bg-[#3E5463]' : type === 4, 'bg-[#C1D5E5]' : type !== 4 }" class="flex justify-start items-center h-[64px] w-full px-[26px] rounded-[12px]">
              <svg xmlns="http://www.w3.org/2000/svg" width="27.685" height="31.499" viewBox="0 0 27.685 31.499">
                <g id="svgexport-6_36_" data-name="svgexport-6 (36)" transform="translate(-31)">
                  <g id="Group_47" data-name="Group 47" transform="translate(31)">
                    <g id="Group_46" data-name="Group 46">
                      <path :class="{ 'fill-white' : type === 4, 'fill-[#3e5463]' : type !== 4 }" id="Path_105" data-name="Path 105" d="M50.1,20.812c3.352-5.26,2.931-4.6,3.027-4.741a10.075,10.075,0,0,0,1.865-5.859A10.151,10.151,0,1,0,36.61,16.146l2.973,4.666C36.4,21.3,31,22.756,31,25.962c0,1.169.763,2.834,4.4,4.132A29.127,29.127,0,0,0,44.842,31.5c6.646,0,13.842-1.875,13.842-5.537C58.685,22.756,53.287,21.3,50.1,20.812ZM38.152,15.131l-.032-.047a8.305,8.305,0,1,1,13.512-.093c-.089.117.375-.6-6.789,10.638Zm6.691,14.523c-7.259,0-12-2.134-12-3.691,0-1.047,2.434-2.768,7.829-3.439l3.39,5.319a.923.923,0,0,0,1.556,0l3.39-5.319c5.394.671,7.829,2.392,7.829,3.439C56.839,27.507,52.144,29.654,44.842,29.654Z" transform="translate(-31)"/>
                    </g>
                  </g>
                  <g id="Group_49" data-name="Group 49" transform="translate(40.228 5.598)">
                    <g id="Group_48" data-name="Group 48">
                      <path :class="{ 'fill-white' : type === 4, 'fill-[#3e5463]' : type !== 4 }" id="Path_106" data-name="Path 106" d="M185.614,91a4.614,4.614,0,1,0,4.614,4.614A4.619,4.619,0,0,0,185.614,91Zm0,7.383a2.768,2.768,0,1,1,2.768-2.768A2.772,2.772,0,0,1,185.614,98.383Z" transform="translate(-181 -91)"/>
                    </g>
                  </g>
                </g>
              </svg>
              <span class="text-[17px] lg:text-[22px] font-bold" :class="{ 'text-white' : type === 4, 'text-[#3E5463]' : type !== 4, 'ml-[15px] lg:ml-[31px]': lang === 'en','mr-[15px] lg:mr-[20px]' : lang === 'ar'  }">
                {{ lang === 'en' ? 'Addresses' : 'العناوين' }}
              </span>
            </button>
          </div>
        </div>
        <div class="w-full xl:w-[calc(100%-260px)] lg:ps-[20px]">
          <template v-if="type === 1">
            <form class="w-full" @submit.prevent="updateSettings">
              <div class="rounded-[10px] shadow-[0_4px_3px_0_#E0E9F0] h-[64px] bg-[#F9FBFC] mb-[10px] px-[29px] py-[9px]">
                <label for="name" class="text-[15px] text-[#3E5463]"> {{ lang === 'en' ? 'Name' : 'اسم' }} </label>
                <input id="name" type="text" name="name" v-model="userData.name" class="bg-transparent w-full border-0 outline-0 block text-[18px] font-bold text-[#3E5463]" autocomplete="off"/>
              </div>
              <div class="rounded-[10px] shadow-[0_4px_3px_0_#E0E9F0] h-[64px] bg-[#F9FBFC] mb-[10px] px-[29px] py-[9px]">
                <label for="mobile" class="text-[15px] text-[#3E5463]"> {{ lang === 'en' ? 'Mobile' : 'متحرك' }} </label>
                <input id="mobile" type="text" name="phone" v-model="userData.phone" class="bg-transparent w-full border-0 outline-0 block text-[18px] font-bold text-[#3E5463]" autocomplete="off" @keypress="validateNumber($event)"/>
              </div>
              <div class="rounded-[10px] shadow-[0_4px_3px_0_#E0E9F0] h-[64px] bg-[#F9FBFC] mb-[10px] px-[29px] py-[9px]">
                <label for="email" class="text-[15px] text-[#3E5463]"> {{ lang === 'en' ? 'Email' : 'بريد إلكتروني' }} </label>
                <input id="email" type="email" name="email" v-model="userData.email" class="bg-transparent w-full border-0 outline-0 block text-[18px] font-bold text-[#3E5463]" autocomplete="off"/>
              </div>
              <div class="rounded-[10px] shadow-[0_4px_3px_0_#E0E9F0] h-[64px] bg-[#F9FBFC] mb-[10px] px-[29px] py-[9px]">
                <label class="text-[15px] text-[#3E5463]"> {{ lang === 'en' ? 'Language' : 'لغة' }} </label>
                <div class="flex justify-start items-center gap-x-[35px]">
                  <label for="english" class="flex justify-start">
                    <input type="radio" :checked="userData.lang == 2" name="language" value="2" id="english" class="sr-only peer" @change="userData.lang = 2;"/>
                    <span class="w-[25px] h-[25px] flex justify-center items-center rounded-full border border-[#C1D5E5] relative before:absolute before:content-[''] before:inset-0 before:w-[21px] before:h-[21px] peer-checked:before:bg-[#C6A798] before:rounded-full before:top-[1px] before:left-[1px] before:transition-all before:duration-300 peer-checked:before:ring-[#C6A798]"></span>
                    <span class="ms-[9px] text-[18px] font-bold text-[#3E5463]"> English </span>
                  </label>
                  <label for="arabic" class="flex justify-start">
                    <input type="radio" :checked="userData.lang == 1" name="language" value="1" id="arabic" class="sr-only peer" @change="userData.lang = 1;"/>
                    <span class="w-[25px] h-[25px] flex justify-center items-center rounded-full border border-[#C1D5E5] relative before:absolute before:content-[''] before:inset-0 before:w-[21px] before:h-[21px] peer-checked:before:bg-[#C6A798] before:rounded-full before:top-[1px] before:left-[1px] before:transition-all before:duration-300 peer-checked:before:ring-[#C6A798]"></span>
                    <span class="ms-[9px] text-[18px] font-bold text-[#3E5463]"> {{lang == 'en' ? 'Arabic' : 'العربية' }} </span>
                  </label>
                </div>
              </div>
              <div class="w-full">
                <button type="submit" class="w-full bg-[#C6A798] hover:bg-[#B28F85] duration-500 rounded-[12px] text-[21px] text-white outline-0 border-0 h-[64px] font-bold" v-if="!settingsLoading">
                  {{ lang == 'en' ? 'Save' : 'يحفظ' }}
                </button>
                <button type="button" class="w-full bg-[#C6A798] rounded-[12px] text-[21px] text-white outline-0 border-0 h-[64px]" v-if="settingsLoading">
                  <span class="w-6 h-6 border-4 border-white border-t-gray-300 rounded-full animate-spin mx-auto block"></span>
                </button>
              </div>
            </form>
          </template>
          <template v-if="type === 2">
            <div class="w-full">
              <div class="flex justify-start flex-wrap xl:flex-nowrap items-start w-full">
                <template v-if="orders.length > 0 && !orderLoading">
                  <div class="w-full xl:max-w-[263px] xl:min-w-[263px]">
                      <div class="mb-[9px] cursor-pointer" v-for="(each) in orders" :key="each.id" @click="selectOrder(each)">
                        <div class="bg-[#E0E9F0] border outline-0 text-white w-full h-[72px] px-[33px] flex justify-start items-center rounded-[7px]" :class="{'bg-[#E0E9F0] border-[#C1D5E5]': !each.active, 'bg-[#C6A798] border-[#C6A798]': each.active}">
                        <div class="inline-block">
                          <div class="text-start text-[18px] 2xl:text-[20px] mb-[-4px] font-bold" :class="{'text-[#3e5463]': !each.active, 'text-[#fff]': each.active}"> {{ lang === 'en' ? 'ORDER' : 'طلب' }} # {{each.id}} </div>
                          <div class="text-start text-[14px] 2xl:text-[18px] font-bold" :class="{'text-[#3e5463]': !each.active, 'text-[#fff]': each.active}"> {{each.created_at_format}} </div>
                        </div>
                        </div>
                      </div>
                  </div>
                  <div class="w-full xl:ps-[21px]" v-if="selectedOrder">
                    <div class="mb-[17px]">
                      <div class="bg-[#E0E9F0] rounded-b-[26px] w-full py-[16px] px-[21px] flex justify-between items-center">
                        <div>
                          <div class="text-[25px] 2xl:text-[37px] font-bold text-[#3E5463]"> {{ lang === 'en' ? 'Track Order' : 'تتبع الطلب' }} </div>
                          <div class="text-[17px] 2xl:text-[20px] font-bold text-[#3E5463] mt-[-12px]"> {{ lang === 'en' ? 'ORDER' : 'طلب' }} # {{selectedOrder.id}}
                          </div>
                        </div>
                        <div>
                          <div class="text-[14px] 2xl:text-[20px] text-[#3E5463] mb-[-7px]"> {{selectedOrder.created_at_format}}</div>
                          <div class="flex justify-between items-center gap-3">
                            <div class="text-[18px] 2xl:text-[26px] text-[#3E5463] mb-[-20px] font-bold"> {{ lang === 'en' ? 'STATUS' : 'حالة' }} </div>
                            <template v-if="selectedOrder.order_status == 1">
                              <div class="text-[18px] 2xl:text-[26px] text-[#3E5463] mb-[-20px] font-bold"> {{ lang === 'en' ? 'Delivered' : 'تم التوصيل' }} </div>
                            </template>
                            <template v-if="selectedOrder.order_status == 2">
                              <div class="text-[18px] 2xl:text-[26px] text-[#3E5463] mb-[-20px] font-bold"> {{ lang === 'en' ? 'Picked up' : 'التقطت' }} </div>
                            </template>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="mb-[6px]" v-if="options > 0">
                      <template v-for="(each) in selectedOrder.order_details" :key="each.id">
                        <div class="w-full bg-white border border-[#C1D5E5] h-[70px] flex justify-start font-bold items-center rounded-[10px]" v-for="(item) in each.orders_options" :key="item.id">
                          <img :src="'assets/images/product.png'" class="w-[86px] h-[64px]" alt="product"/>
                          <div>
                            <div class="text-[20px] font-bold text-[#3E5463]">
                              {{each.title}}
                            </div>
                            <div class="text-[14px] font-bold mt-[-5px] text-[#3E5463] leading-[15px] pe-10">
                              {{item.title}}
                            </div>
                          </div>
                          <div class="border-l border-black w-[68px] text-[#3E5463] flex justify-center items-center h-[45px]">
                            {{ item.quantity }}
                          </div>
                          <div class="border border-[#C1D5E5] w-[139px] text-[#3E5463] flex justify-center items-center h-[70px] rounded-[10px]">
                            {{item.quantity * item.price}} {{ lang === 'en' ? 'Sar' : 'سار' }}
                          </div>
                        </div>
                      </template>
                    </div>
                    <div class="mb-[6px] w-full bg-white border border-[#C1D5E5] h-[70px] flex justify-center font-bold items-center rounded-[10px]" v-if="options == 0">
                      {{lang == 'en' ? 'No order options found.' : 'لم يتم العثور على خيارات الطلب.'}}
                    </div>
                    <div class="flex justify-end mb-[2px] font-bold">
                      <div class="w-full xl:w-[366px] h-[40px] rounded-[10px] text-[#3E5463] border border-[#C1D5E5] flex justify-end">
                        <div class="xl:w-[calc(100%-95px)] h-[40px] flex justify-end items-center pe-[28px]">
                         {{ lang === 'en' ? 'Products Value' : 'قيمة المنتجات' }}
                        </div>
                        <div class="w-[95px] h-[40px] flex justify-end items-center pr-2">
                          {{selectedOrder.order_details[0].price * selectedOrder.order_details[0].quantity}} {{ lang === 'en' ? 'Sar' : 'سار' }}
                        </div>
                      </div>
                    </div>
                    <div class="flex justify-end mb-[2px] font-bold">
                      <div class="w-full xl:w-[366px] h-[40px] rounded-[10px] text-[#3E5463] border border-[#C1D5E5] flex justify-end">
                        <div class="xl:w-[calc(100%-95px)] h-[40px] flex justify-end items-center pe-[28px]">
                          {{ lang === 'en' ? 'VAT (15%)' : 'ضريبة القيمة المضافة (15%)' }}
                        </div>
                        <div class="w-[95px] h-[40px] flex justify-end items-center pr-2">
                          {{selectedOrder.vat}} {{ lang === 'en' ? 'Sar' : 'سار' }}
                        </div>
                      </div>
                    </div>
                    <div class="flex justify-end mb-[2px] font-bold">
                      <div class="w-full xl:w-[366px] h-[40px] rounded-[10px] text-[#3E5463] border border-[#C1D5E5] flex justify-end">
                        <div class="w-[calc(100%-95px)] h-[40px] flex justify-end items-center pe-[28px]">
                          {{ lang === 'en' ? 'Delivery' : 'توصيل' }}
                        </div>
                        <div class="w-[95px] h-[40px] flex justify-end items-center pr-2">
                          {{selectedOrder.delivery_price}} {{ lang === 'en' ? 'Sar' : 'سار' }}
                        </div>
                      </div>
                    </div>
                    <div class="flex justify-end mb-[2px] font-bold">
                      <div class="w-full xl:w-[366px] h-[40px] rounded-[10px] text-[#3E5463] border border-[#C1D5E5] flex justify-end">
                        <div class="w-[calc(100%-95px)] h-[40px] flex justify-end items-center pe-[28px]">
                          {{ lang === 'en' ? 'Delivery VAT (15%)' : 'ضريبة القيمة المضافة على التوصيل (15%)' }}
                        </div>
                        <div class="w-[95px] h-[40px] flex justify-end items-center pr-2">
                          {{selectedOrder.delivery_vat}} {{ lang === 'en' ? 'Sar' : 'سار' }}
                        </div>
                      </div>
                    </div>
                    <div class="flex justify-end">
                      <div class="w-[366px] h-[40px] rounded-[10px] border border-[#C6A798] text-white font-bold bg-[#C6A798] flex justify-end">
                        <div class="w-[calc(100%-95px)] h-[40px] flex justify-end items-center pe-[28px]">
                          {{ lang === 'en' ? 'Total' : 'المجموع' }}
                        </div>
                        <div class="w-[95px] h-[40px] flex justify-end items-center pr-2">
                          {{selectedOrder?.total}} {{ lang === 'en' ? 'Sar' : 'سار' }}
                        </div>
                      </div>
                    </div>
                  </div>
                </template>

                <template v-if="orders.length == 0 && !orderLoading">
                  <div class="w-full flex h-[300px] items-center justify-center">{{lang == 'en' ? 'No orders found.' : 'لم يتم العثور على أي أوامر.'}}</div>
                </template>
                <div v-if="orderLoading" class="h-[200px] w-full flex items-center justify-center">
                  <LoaderVue/>
                </div>
              </div>
            </div>
          </template>
          <template v-if="type === 3">
            <form class="flex justify-start items-start flex-wrap w-full">
              <div class="w-full xl:w-2/4">
                <div class="w-full">
                  <div class="mb-[8px]">
                    <button type="button" class="w-full border outline-0 border-[#C6A798] rounded-[7px] h-[72px] bg-[#C6A798] flex justify-start items-center px-[16px]">
                      <span class="flex justify-start items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="38.384" height="30.235" viewBox="0 0 38.384 30.235">
                          <rect id="Rectangle_59" data-name="Rectangle 59" width="38.384" height="12.787" transform="translate(0 17.448)" fill="#84b740"/>
                          <rect id="Rectangle_60" data-name="Rectangle 60" width="38.384" height="12.798" fill="#259bd6"/>
                        </svg>
                        <span class="ml-[4.7px]">
                          <img :src="'assets/images/payment-text.png'" alt="payment-text">
                        </span>
                      </span>
                      <span class="ml-[34px] text-white text-start font-bold">
                        <span class="block mb-[-5px]"> {{ lang === 'en' ? 'Ending' : 'إنهاء' }} </span>
                        <span class="block mb-[-5px]"> 6546 </span>
                      </span>
                      <span class="ml-[18px]">
                        <svg xmlns="http://www.w3.org/2000/svg" width="36.832" height="37" viewBox="0 0 36.832 37">
                          <g id="svgexport-6_29_" data-name="svgexport-6 (29)" transform="translate(-8 -8)">
                            <g id="Checkmark" transform="translate(8 8)">
                              <path id="Path_90" data-name="Path 90" d="M26.416,8A18.5,18.5,0,1,0,44.832,26.5,18.458,18.458,0,0,0,26.416,8Zm10.29,13.42L25.2,32.983a1.514,1.514,0,0,1-2.164,0l-5.371-5.4a1.542,1.542,0,0,1,0-2.174,1.525,1.525,0,0,1,2.164,0l4.289,4.3L34.542,19.246a1.525,1.525,0,0,1,2.164,0,1.542,1.542,0,0,1,0,2.174Z" transform="translate(-8 -8)" fill="#fcfcfc"/>
                              <path id="Path_91" data-name="Path 91" d="M39.411,24.606,27.953,36.064a1.512,1.512,0,0,1-2.154,0l-5.347-5.347a1.523,1.523,0,1,1,2.154-2.154l4.27,4.262L37.257,22.452a1.523,1.523,0,1,1,2.154,2.154Z" transform="translate(-10.744 -11.146)" fill="#3e5463"/>
                            </g>
                          </g>
                        </svg>
                      </span>
                    </button>
                  </div>
                  <div class="mb-[8px]">
                    <button type="button" class="w-full border outline-0 border-[#C1D5E5] rounded-[7px] h-[72px] bg-[#E0E9F0] flex justify-start items-center px-[16px]">
                      <span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="65.977" height="51.196" viewBox="0 0 65.977 51.196">
                          <g id="Group_44" data-name="Group 44" transform="translate(0 0)" opacity="0.35">
                            <path id="Path_92" data-name="Path 92" d="M21.617,176.184v-3.4a1.993,1.993,0,0,0-2.152-2.152,2.234,2.234,0,0,0-1.926.963,1.981,1.981,0,0,0-1.812-.963,1.829,1.829,0,0,0-1.586.793v-.68H12.952v5.437h1.189v-3c0-.963.51-1.416,1.3-1.416s1.189.51,1.189,1.416v3h1.189v-3a1.253,1.253,0,0,1,1.3-1.416c.793,0,1.189.51,1.189,1.416v3Zm17.613-5.437H37.3V169.1H36.115v1.642H35.039v1.076h1.076v2.492c0,1.246.51,1.982,1.869,1.982a3.168,3.168,0,0,0,1.473-.4l-.34-1.02a1.863,1.863,0,0,1-1.019.283c-.566,0-.793-.34-.793-.906v-2.435h1.925v-1.076Zm10.081-.113a1.6,1.6,0,0,0-1.416.793v-.68H46.705v5.437h1.189v-3.058c0-.906.4-1.416,1.133-1.416a3.307,3.307,0,0,1,.736.113l.34-1.133a3.746,3.746,0,0,0-.793-.057Zm-15.234.566a3.887,3.887,0,0,0-2.209-.566c-1.359,0-2.265.68-2.265,1.756,0,.906.68,1.416,1.869,1.586l.566.057c.623.113.963.283.963.567,0,.4-.453.68-1.246.68a3.127,3.127,0,0,1-1.812-.566l-.566.906a4.005,4.005,0,0,0,2.322.68c1.586,0,2.492-.736,2.492-1.756,0-.963-.736-1.473-1.869-1.642l-.566-.057c-.51-.057-.906-.17-.906-.51,0-.4.4-.623,1.019-.623a4.081,4.081,0,0,1,1.7.453l.51-.963Zm31.6-.566a1.6,1.6,0,0,0-1.416.793v-.68H63.072v5.437h1.189v-3.058c0-.906.4-1.416,1.133-1.416a3.307,3.307,0,0,1,.736.113l.34-1.133a3.746,3.746,0,0,0-.793-.057ZM50.5,173.465a2.72,2.72,0,0,0,2.888,2.832,2.818,2.818,0,0,0,1.925-.623l-.566-.963a2.288,2.288,0,0,1-1.416.51,1.608,1.608,0,0,1-1.642-1.756,1.671,1.671,0,0,1,1.642-1.756,2.287,2.287,0,0,1,1.416.51l.566-.963a2.816,2.816,0,0,0-1.925-.623,2.72,2.72,0,0,0-2.888,2.832Zm10.987,0v-2.718H60.3v.68a2.047,2.047,0,0,0-1.7-.793,2.834,2.834,0,0,0,0,5.663,1.906,1.906,0,0,0,1.7-.793v.68h1.189Zm-4.361,0a1.646,1.646,0,1,1,3.285,0,1.646,1.646,0,1,1-3.285,0Zm-14.215-2.832a2.833,2.833,0,0,0,.056,5.663,3.465,3.465,0,0,0,2.209-.736l-.567-.85a2.706,2.706,0,0,1-1.586.566,1.529,1.529,0,0,1-1.643-1.3H45.4v-.453a2.5,2.5,0,0,0-2.492-2.888Zm0,1.019a1.325,1.325,0,0,1,1.359,1.3H41.438a1.434,1.434,0,0,1,1.473-1.3Zm29.506,1.812V168.6H71.227v2.832a2.047,2.047,0,0,0-1.7-.793,2.834,2.834,0,0,0,0,5.663,1.906,1.906,0,0,0,1.7-.793v.68h1.189Zm-4.361,0a1.646,1.646,0,1,1,3.285,0,1.646,1.646,0,1,1-3.285,0Zm-39.756,0v-2.718H27.11v.68a2.047,2.047,0,0,0-1.7-.793,2.834,2.834,0,0,0,0,5.663,1.906,1.906,0,0,0,1.7-.793v.68H28.3Zm-4.417,0a1.646,1.646,0,1,1,3.285,0,1.646,1.646,0,1,1-3.285,0Z" transform="translate(-9.611 -125.101)"/>
                            <rect id="Rectangle_72" data-name="Rectangle 72" width="17.839" height="32.054" transform="translate(24.069 4.361)" fill="#ff5f00"/>
                            <path id="Path_93" data-name="Path 93" d="M25.2,20.388A20.442,20.442,0,0,1,32.96,4.361,20.38,20.38,0,1,0,20.388,40.776,20.261,20.261,0,0,0,32.96,36.415,20.357,20.357,0,0,1,25.2,20.388Z" fill="#eb001b"/>
                            <path id="Path_94" data-name="Path 94" d="M160.943,20.388a20.366,20.366,0,0,1-32.96,16.027,20.433,20.433,0,0,0,0-32.054,20.366,20.366,0,0,1,32.96,16.027Z" transform="translate(-94.966)" fill="#f79e1b"/>
                          </g>
                        </svg>
                      </span>
                      <span class="ml-[59px] text-[#3E5463] opacity-50 text-start font-bold">
                        <span class="block mb-[-5px]"> {{ lang === 'en' ? 'Ending' : 'إنهاء' }} </span>
                        <span class="block mb-[-5px]"> 6546 </span>
                      </span>
                      <span class="ml-[18px] invisible">
                        <svg xmlns="http://www.w3.org/2000/svg" width="36.832" height="37" viewBox="0 0 36.832 37">
                          <g id="svgexport-6_29_" data-name="svgexport-6 (29)" transform="translate(-8 -8)">
                            <g id="Checkmark" transform="translate(8 8)">
                              <path id="Path_90" data-name="Path 90" d="M26.416,8A18.5,18.5,0,1,0,44.832,26.5,18.458,18.458,0,0,0,26.416,8Zm10.29,13.42L25.2,32.983a1.514,1.514,0,0,1-2.164,0l-5.371-5.4a1.542,1.542,0,0,1,0-2.174,1.525,1.525,0,0,1,2.164,0l4.289,4.3L34.542,19.246a1.525,1.525,0,0,1,2.164,0,1.542,1.542,0,0,1,0,2.174Z" transform="translate(-8 -8)" fill="#fcfcfc"/>
                              <path id="Path_91" data-name="Path 91" d="M39.411,24.606,27.953,36.064a1.512,1.512,0,0,1-2.154,0l-5.347-5.347a1.523,1.523,0,1,1,2.154-2.154l4.27,4.262L37.257,22.452a1.523,1.523,0,1,1,2.154,2.154Z" transform="translate(-10.744 -11.146)" fill="#3e5463"/>
                            </g>
                          </g>
                        </svg>
                      </span>
                    </button>
                  </div>
                  <div class="w-full mb-3">
                    <button type="button" class="bg-[#E0E9F0] border border-[#C1D5E5] outline-0 w-full h-[72px] flex justify-center items-center rounded-[7px]">
                      <span class="inline-block text-[#3e5463] mb-[-4px] font-bold text-[17px] 2xl:text-[22px] mr-[11px]">
                        {{ lang === 'en' ? 'Add Another Card' : 'أضف بطاقة أخرى' }}
                      </span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33.408 33.408">
                        <g id="svgexport-6_6_" data-name="svgexport-6 (6)" transform="translate(-181 -93)">
                          <path id="Path_21" data-name="Path 21" d="M16.7,0a16.7,16.7,0,1,0,16.7,16.7A16.723,16.723,0,0,0,16.7,0Zm7.308,18.1H18.1v5.916a1.392,1.392,0,0,1-2.784,0V18.1H9.4a1.392,1.392,0,1,1,0-2.784h5.916V9.4a1.392,1.392,0,1,1,2.784,0v5.916h5.916a1.392,1.392,0,0,1,0,2.784Zm0,0" transform="translate(181 93)" fill="#3e5463"/>
                        </g>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
              <div class="w-full xl:w-2/4 xl:ps-[21px]">
                <div class="w-full bg-[#E0E9F0] h-[214px] rounded-[12px] pt-[46px] px-[26px]">
                  <div class="flex justify-end items-center">
                    <div class="w-[100px] h-[54px] flex justify-center items-center bg-[#C1D5E5] rounded-[12px]">
                      <img :src="'assets/images/card-name.png'" class="w-[67.77px] h-[22.6px]" alt="card-name">
                    </div>
                  </div>
                  <input type="text" class="text-[20px] mt-[10px] text-[#3E5463] w-full font-bold bg-transparent outline-0 border-0" value="4859 8566 4666 6546" autocomplete="off" :placeholder=" lang === 'en' ? 'Enter your cardholder number' : 'أدخل رقم حامل البطاقة الخاص بك' " />
                  <div class="grid grid-cols-2">
                    <div class="mt-[13px]">
                      <div class="text-[15px] font-normal text-[#3E5463]"> {{ lang === 'en' ? 'Name' : 'اسم' }} </div>
                      <input type="text" class="text-[15px] font-bold text-[#3E5463] w-full bg-transparent outline-0 border-0" value="Yousef Abuzaid" autocomplete="off" :placeholder=" lang === 'en' ? 'Enter your cardholder name' : 'أدخل اسم حامل البطاقة الخاص بك' " />
                    </div>
                    <div class="mt-[13px]">
                      <div class="text-[15px] font-normal text-[#3E5463]"> {{ lang === 'en' ? 'EXPIRES' : 'تنتهي' }} </div>
                      <input type="text" class="text-[15px] font-bold text-[#3E5463] w-full bg-transparent outline-0 border-0" value="02 /2025" autocomplete="off" :placeholder=" lang === 'en' ? 'Enter your cardholder expires' : 'أدخل تاريخ انتهاء صلاحية حامل البطاقة الخاص بك' " />
                    </div>
                  </div>
                </div>
                <div class="mt-[9px] bg-[#F9FBFC] rounded-[10px] shadow-[0_4px_3px__#E0E9F0] px-[29px] py-[9px]">
                  <div class="text-[15px] text-[#3E5463] font-normal"> {{ lang === 'en' ? 'Cardholder Name' : 'اسم حامل البطاقة' }} </div>
                  <input type="text" class="text-[18px] text-[#3E5463] font-bold w-full bg-transparent outline-0 border-0" value="Yousef Abuzaid" autocomplete="off" :placeholder=" lang === 'en' ? 'Enter your cardholder name' : 'أدخل اسم حامل البطاقة الخاص بك' " />
                </div>
                <div class="mt-[9px] bg-[#F9FBFC] rounded-[10px] shadow-[0_4px_3px__#E0E9F0] px-[29px] py-[9px]">
                  <div class="text-[15px] text-[#3E5463] font-normal"> {{ lang === 'en' ? 'Card Number' : 'رقم البطاقة' }} </div>
                  <input type="text" class="text-[18px] text-[#3E5463] font-bold w-full bg-transparent outline-0 border-0" value="4859 8566 4666 6546" autocomplete="off" :placeholder=" lang === 'en' ? 'Enter your cardholder number' : 'أدخل رقم حامل البطاقة الخاص بك' " />
                </div>
                <div class="mt-[9px] grid grid-cols-2 gap-3">
                  <div class="bg-[#F9FBFC] rounded-[10px] shadow-[0_4px_3px__#E0E9F0] px-[29px] py-[9px]">
                    <div class="text-[15px] text-[#3E5463] font-normal">
                      {{ lang === 'en' ? 'EXPIRES' : 'تنتهي' }}
                    </div>
                    <input type="text" class="text-[18px] text-[#3E5463] font-bold w-full bg-transparent outline-0 border-0" value="02/25" autocomplete="off" :placeholder=" lang === 'en' ? 'Enter your cardholder expires' : 'أدخل تاريخ انتهاء صلاحية حامل البطاقة الخاص بك' " />
                  </div>
                  <div class="bg-[#F9FBFC] rounded-[10px] shadow-[0_4px_3px__#E0E9F0] px-[29px] py-[9px]">
                    <div class="text-[15px] text-[#3E5463] font-normal">
                      {{ lang === 'en' ? 'CVV' : 'CVV' }}
                    </div>
                    <input type="text" class="text-[18px] text-[#3E5463] font-bold w-full bg-transparent outline-0 border-0" value="559" autocomplete="off" :placeholder=" lang === 'en' ? 'Enter your cardholder cvv' : 'أدخل رقم البطاقة CVV الخاص بك' " />
                  </div>
                </div>
                <div class="mt-[9px] border border-[#C6A798] rounded-[10px] px-[21px] py-[14px] text-[20px] font-bold text-[#3E5463] flex justify-between items-center">
                  {{ lang === 'en' ? 'Save this card for later' : 'احفظ هذه البطاقة لاستخدامها لاحقًا' }}
                  <img :src="'assets/images/check-circle.svg'" width="33.26" height="33.41" alt="check-circle"/>
                </div>
                <div class="mt-[9px] bg-[#C6A798] rounded-[12px] py-[18px] text-center mb-0 text-white text-[21px]">Pay
                  {{ lang === 'en' ? 'with card' : 'مع البطاقة' }}
                </div>
              </div>
            </form>
          </template>
          <template v-if="type === 4">
            <form class="flex justify-start flex-wrap xl:flex-nowrap items-start w-full">
              <div class="xl:max-w-[363px] w-full">
                <div class="max-h-[332px] mb-5 overflow-y-scroll scrollbar" v-if="addresses.length > 0 && !getAddressLoading">
                  <div class="mb-[9px]" v-for="(each) in addresses" :key="each.id">
                    <div class="border-[#C6A798] outline-0 text-white w-full h-[72px] px-[22px] flex justify-start items-center rounded-[7px] cursor-pointer" :class="{'bg-[#C6A798]': each.active, 'bg-[#C1D5E5]': !each.active}" @click="changeAddress(each)">
                      <span class="inline-block">
                        <svg xmlns="http://www.w3.org/2000/svg" class="w-[27.685px] h-[31.499px]" viewBox="0 0 27.685 31.499">
                          <g id="svgexport-6_36_" data-name="svgexport-6 (36)" transform="translate(-31)">
                            <g id="Group_47" data-name="Group 47" transform="translate(31)">
                              <g id="Group_46" data-name="Group 46">
                                <path id="Path_105" data-name="Path 105" d="M50.1,20.812c3.352-5.26,2.931-4.6,3.027-4.741a10.075,10.075,0,0,0,1.865-5.859A10.151,10.151,0,1,0,36.61,16.146l2.973,4.666C36.4,21.3,31,22.756,31,25.962c0,1.169.763,2.834,4.4,4.132A29.127,29.127,0,0,0,44.842,31.5c6.646,0,13.842-1.875,13.842-5.537C58.685,22.756,53.287,21.3,50.1,20.812ZM38.152,15.131l-.032-.047a8.305,8.305,0,1,1,13.512-.093c-.089.117.375-.6-6.789,10.638Zm6.691,14.523c-7.259,0-12-2.134-12-3.691,0-1.047,2.434-2.768,7.829-3.439l3.39,5.319a.923.923,0,0,0,1.556,0l3.39-5.319c5.394.671,7.829,2.392,7.829,3.439C56.839,27.507,52.144,29.654,44.842,29.654Z" transform="translate(-31)" fill="#fff" :class="{'fill-[#fff]': each.active, 'fill-[#3e5463]': !each.active}" />
                              </g>
                            </g>
                            <g id="Group_49" data-name="Group 49" transform="translate(40.228 5.598)">
                              <g id="Group_48" data-name="Group 48">
                                <path id="Path_106" data-name="Path 106" d="M185.614,91a4.614,4.614,0,1,0,4.614,4.614A4.619,4.619,0,0,0,185.614,91Zm0,7.383a2.768,2.768,0,1,1,2.768-2.768A2.772,2.772,0,0,1,185.614,98.383Z" transform="translate(-181 -91)" fill="#fff" :class="{'fill-[#fff]': each.active, 'fill-[#3e5463]': !each.active}"/>
                              </g>
                            </g>
                          </g>
                        </svg>
                      </span>
                      <div class="inline-block ms-[25.3px] w-full">
                        <div class="text-start text-[20px] mb-[-4px] font-bold truncate-to-1-line" :class="{'text-[#fff]': each.active, 'text-[#3e5463]': !each.active}"> {{ each.name }}
                        </div>
                        <div class="text-start text-[12px] font-bold truncate-to-2-line" :class="{'text-[#fff]': each.active, 'text-[#3e5463]': !each.active}">
                          {{ each.building_details }}
                        </div>
                      </div>
                      <span class="inline-block" v-if="each.active">
                        <svg xmlns="http://www.w3.org/2000/svg" width="36.832" height="37" viewBox="0 0 36.832 37">
                          <g id="svgexport-6_29_" data-name="svgexport-6 (29)" transform="translate(-8 -8)">
                            <g id="Checkmark" transform="translate(8 8)">
                              <path id="Path_90" data-name="Path 90" d="M26.416,8A18.5,18.5,0,1,0,44.832,26.5,18.458,18.458,0,0,0,26.416,8Zm10.29,13.42L25.2,32.983a1.514,1.514,0,0,1-2.164,0l-5.371-5.4a1.542,1.542,0,0,1,0-2.174,1.525,1.525,0,0,1,2.164,0l4.289,4.3L34.542,19.246a1.525,1.525,0,0,1,2.164,0,1.542,1.542,0,0,1,0,2.174Z" transform="translate(-8 -8)" fill="#fcfcfc"/>
                              <path id="Path_91" data-name="Path 91" d="M39.411,24.606,27.953,36.064a1.512,1.512,0,0,1-2.154,0l-5.347-5.347a1.523,1.523,0,1,1,2.154-2.154l4.27,4.262L37.257,22.452a1.523,1.523,0,1,1,2.154,2.154Z" transform="translate(-10.744 -11.146)" fill="#3e5463"/>
                            </g>
                          </g>
                        </svg>
                      </span>
                    </div>
                  </div>
                </div>
                <div v-if="getAddressLoading" class="h-[200px] w-full flex items-center justify-center">
                  <LoaderVue/>
                </div>
                <div class="mb-[9px]">
                  <button type="button" class="bg-[#C1D5E5] border-[#C6A798] outline-0 w-full h-[72px] px-[22px] flex justify-start items-center rounded-[7px]" @click="resetAddress">
                      <span class="inline-block text-[#3e5463] mb-[-4px] font-bold text-[17px] 2xl:text-[22px] flex-1">
                        {{ lang === 'en' ? 'Add Another Address' : 'أضف عنوانًا آخر' }}
                      </span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="33.408" height="33.408" viewBox="0 0 33.408 33.408">
                      <g id="svgexport-6_6_" data-name="svgexport-6 (6)" transform="translate(-181 -93)">
                        <path id="Path_21" data-name="Path 21" d="M16.7,0a16.7,16.7,0,1,0,16.7,16.7A16.723,16.723,0,0,0,16.7,0Zm7.308,18.1H18.1v5.916a1.392,1.392,0,0,1-2.784,0V18.1H9.4a1.392,1.392,0,1,1,0-2.784h5.916V9.4a1.392,1.392,0,1,1,2.784,0v5.916h5.916a1.392,1.392,0,0,1,0,2.784Zm0,0" transform="translate(181 93)" fill="#3e5463"/>
                      </g>
                    </svg>
                  </button>
                </div>
              </div>
              <div class="w-full xl:ps-[21px]">
                <div class="mb-[17px]">
                  <div class="relative">
                    <!--google map-->
                    <SettingsMap :activeLocation="activeLocation" @handleAddress="handleAddress"/>
                  </div>
                </div>
                <form @submit.prevent="manageAddress">
                  <div class="rounded-[10px] shadow-[0_0_8px_0_#E0E9F0] h-[64px] mb-[6px] px-[29px] py-[9px]">
                    <label for="name" class="text-[15px] text-[#3E5463]">
                      {{ lang === 'en' ? 'Address Name' : 'اسم العنوان' }}
                    </label>
                    <input id="name" type="text" name="name" v-model="address.name" class="w-full border-0 outline-0 block text-[18px] font-bold text-[#3E5463]" autocomplete="off"/>
                  </div>
                  <div class="text-red-700" v-if="addressError && addressError?.name">
                    {{ lang == 'en' ? 'Name is required.' : 'الاسم مطلوب.' }}.
                  </div>
                  <div class="rounded-[10px] shadow-[0_0_8px_0_#E0E9F0] h-[64px] mb-[6px] px-[29px] py-[9px]">
                    <label for="mobile" class="text-[15px] text-[#3E5463]">
                      {{ lang === 'en' ? 'Building Number' : 'رقم المبنى' }}
                    </label>
                    <input id="mobile" type="text" name="building_details" v-model="address.building_details" class="w-full border-0 outline-0 block text-[18px] font-bold text-[#3E5463]" autocomplete="off"/>
                  </div>
                  <div class="text-red-700" v-if="addressError && addressError?.building_details">
                    {{ lang == 'en' ? 'Building number is required.' : 'رقم المبنى مطلوب.' }}
                  </div>
                  <div class="w-full flex items-center gap-2">
                    <div :class="{'w-full': !address.id, 'w-1/2': address.id}">
                      <button type="submit" class="bg-[#C6A798] w-full text-white text-[21px] font-bold flex justify-center items-center rounded-[12px] h-[64px]" v-if="!manageAddressLoading">
                        {{ lang === 'en' ? 'Save Address' : 'حفظ العنوان' }}
                      </button>
                      <button type="button" class="bg-[#C6A798] w-full text-white text-[21px] font-bold flex justify-center items-center rounded-[12px] h-[64px]" v-if="manageAddressLoading">
                        <span class="w-6 h-6 border-4 border-white border-t-gray-300 rounded-full animate-spin mx-auto block"></span>
                      </button>
                    </div>
                    <div class="w-1/2" v-if="address.id">
                      <button type="button" class="w-full h-[64px] bg-[#B21221] hover:bg-[#9B101E] duration-500 text-white rounded-[10px] flex justify-center items-center" @click="deleteAddress" v-if="!deleteAddressLoading">
                        {{ lang === 'en' ? 'Delete' : 'يمسح' }}
                      </button>
                      <button type="button" class="w-full h-[64px] bg-[#B21221] hover:bg-[#9B101E] duration-500 text-white rounded-[10px] flex justify-center items-center" :disabled="true" v-if="deleteAddressLoading">
                      <span class="w-6 h-6 border-4 border-white border-t-gray-300 rounded-full animate-spin mx-auto block"></span>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </form>
          </template>
        </div>
      </div>
      <div class="h-[300px] flex items-center justify-center" v-if="loading">
        <LoaderVue/>
      </div>
    </div>
  </div>
</template>
<script>
import ApiService from "@/service/apiService";
import LoaderVue from "@/components/Loader.vue";
import getUserInfo from "@/utils/getUserInfo";
import {createToaster} from "@meforma/vue-toaster";
import Cookies from "js-cookie";
import SettingsMap from "@/components/SettingsMap.vue";

const toaster = createToaster({
  position: 'top-right'
});

export default {
  name: 'SettingsModal',
  components: {SettingsMap, LoaderVue},
  data() {
    return {
      lang: window?.core?.lang,
      type: 1,
      userData: null,
      loading: false,
      userInfo: null,
      addressError: null,
      settingsLoading: false,
      addresses: [],
      getAddressLoading: false,
      manageAddressLoading: false,
      deleteAddressLoading: false,
      address: {
        id: '',
        user_id: '',
        name: '',
        lat: '',
        long: '',
        alt: '',
        building_details: '',
        type: '',
      },
      activeLocation: {
        lat: '',
        long: ''
      },
      orderLoading: false,
      orders: [],
      selectedOrder: null,
      options: 0
    }
  },
  props: {
    settingsModal: {
      required: true
    }
  },
  methods: {

    setType(type) {
      this.type = type
      if(this.type == 4){
        this.addressError = null;
        this.getAddress();
      }
      if(this.type == 2){
        this.getOrders();
      }
    },

    closeModal() {
      this.$emit('handleCloseModal');
    },

    async getSettings() {
      try {
        this.loading = true;
        const url = `/settings/get`;
        const response = await ApiService.post(url, {user_id: this.userInfo?.client?.id});
        this.userData = response.data.data;
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        this.loading = false;
      }
    },

    async updateSettings() {
      try {
        this.settingsLoading = true;
        const url = `/settings/update`;
        const response = await ApiService.post(url, {user_id: this.userInfo.client.id, ...this.userData});
        if (response.success) {
          toaster.info(this.lang == 'en' ? 'Settings has been updated successfully.' : 'تم تحديث الإعدادات بنجاح.');
        }
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        this.settingsLoading = false;
      }
    },

    async getAddress() {
      try {
        this.getAddressLoading = true;
        const url = `/settings/address/get`;
        const response = await ApiService.post(url, {user_id: this.userInfo.client.id});
        this.addresses = response.data.data;
     /*   this.addresses.forEach((each, index) => {
          if (index == 0) {
            each.active = true;
          } else {
            each.active = false;
          }
          this.address = {...each};
        })*/
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        this.getAddressLoading = false;
      }
    },

    async manageAddress() {
      this.addressError = null;
      try {
        if (this.address.id && (!this.address.name || !this.address.building_details)) {
          this.addressError = {
            name: false,
            building_details: false
          }
          if (!this.address.name) {
            this.addressError.name = true;
          }
          if (!this.address.building_details) {
            this.addressError.building_details = true;
          }
          return;
        }
        this.manageAddressLoading = true;
        const url = this.address.id ? `settings/address/update` : `settings/address/add`;
        this.address = {
          ...this.address,
          user_id: this.userInfo.client.id
        }
        if (this.address.id) {
          this.address.addr_id = String(this.address.id);
        }
        const response = await ApiService.post(url, this.address);
        if (response.data?.error) {
          this.addressError = response.data.error;
        }
        if (response.data.status === 200) {
          if (this.address.id) {
            toaster.info(this.lang == 'en' ? 'Address has been updated successfully.' : 'تم تحديث العنوان بنجاح.');
          } else {
            toaster.info(this.lang == 'en' ? 'Address has been saved successfully.' : 'تم حفظ العنوان بنجاح.');
          }
          this.resetAddress();
          this.getAddress();
        }
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        this.manageAddressLoading = false;
      }
    },

    resetAddress() {
      this.address = {
        id: '',
        user_id: '',
        name: '',
        lat: '',
        long: '',
        alt: '',
        building_details: '',
        type: '',
      }
      this.addresses.forEach(each => {
        each.active = false;
      })
      let activeLocation = Cookies.get('active_location');
      if (activeLocation) {
        activeLocation = JSON.parse(activeLocation);
        this.address.lat = activeLocation.lat.toString();
        this.address.long = activeLocation.long.toString();
      }
    },

    changeAddress(data){
      this.address = {...data};
      this.addresses.forEach(each => {
        if(data.id == each.id){
          each.active = true;
        }else {
          each.active = false;
        }
      })
    },

    async deleteAddress() {
      if (this.userInfo) {
        try {
          this.deleteAddressLoading = true;
          const url = `settings/address/delete`;
          const data = {
            user_id: this.userInfo.client.id,
            addr_id: String(this.address.id)
          }
          const response = await ApiService.post(url, data);
          if (response.data.status === 200) {
            toaster.info(this.lang == 'en' ? 'Address has been deleted successfully.' : 'تم حذف العنوان بنجاح.');
            this.getAddress();
            this.resetAddress();
          }
        } catch (error) {
          console.error("Error fetching users:", error);
        } finally {
          this.deleteAddressLoading = false;
        }
      }
    },

    handleAddress(data) {
      this.address = {
        ...this.address,
        lat: data.lat.toString(),
        long: data.lng.toString()
      }
      Cookies.set('active_location', JSON.stringify({lat: data.lat, long: data.lng}));
    },

    async getOrders() {
      const userInfo = getUserInfo();
      if (userInfo) {
        try {
          this.orderLoading = true;
          const url = `/payment/get/order`;
          const response = await ApiService.post(url, {customer_id: userInfo.client.id});
          this.orders = response.data.data;
          this.orders.forEach((each, index) => {
            each.vat = Number(((each.order_details[0].price * each.order_details[0].quantity) * .15).toFixed(2));
            each.delivery_vat = Number((each.delivery_price * .15).toFixed(2));
            let optionsPrice = 0;
            each.order_details[0].orders_options.forEach(item => {
              optionsPrice += (item.quantity * item.price);
            })
            each.total = each.vat + (each.order_details[0].price * each.order_details[0].quantity) + each.delivery_vat + each.delivery_price + optionsPrice;
            this.options = each.order_details[0].orders_options.length;
            if(index == 0){
              each.active = true;
              this.selectedOrder = each;
            }else {
              each.active = false;
            }
          })
        } catch (error) {
          console.error("Error fetching users:", error);
        } finally {
          this.orderLoading = false;
        }
      }
    },

    selectOrder(data){
      this.orders.forEach(each => {
        if(each.id == data.id){
          each.active = true;
        }else {
          each.active = false;
        }
        this.selectedOrder = data;
      })
    },

    validateNumber(evt) {
      evt.stopPropagation();
      var theEvent = evt || window.event;

      // Handle paste
      if (theEvent.type === 'paste') {
        // @ts-ignore
        key = event.clipboardData.getData('text/plain');
      } else {
        // Handle key press
        var key = theEvent.keyCode || theEvent.which;
        key = String.fromCharCode(key);
      }
      var regex = /^\d*\.?\d*$/;
      if (!regex.test(key)) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) theEvent.preventDefault();
      }
    },
  },
  mounted() {
    const userInfo = getUserInfo();
    if (userInfo) {
      this.userInfo = userInfo;
      this.getSettings();
    }
    let currentLocation = Cookies.get('current_location');
    if (currentLocation) {
      currentLocation = JSON.parse(currentLocation);
      this.activeLocation.lat = currentLocation.lat.toString();
      this.activeLocation.long = currentLocation.long.toString();
      this.address.lat =  currentLocation.lat.toString();
      this.address.long = currentLocation.long.toString();
      Cookies.remove('active_location');
      Cookies.set('active_location', JSON.stringify({lat: currentLocation.lat, long: currentLocation.long}));
    }
  }
}
</script>